import { currentRefinements } from 'instantsearch.js/es/widgets';

const translations = window?.languageTranslations;

export const initCurrentRefinements = () => {
	const appliedFacetsBadges = document.querySelector('.applied-facets__badges');
	const facetsTitles = JSON.parse(translations);

	return currentRefinements({
		container: appliedFacetsBadges,
		cssClasses: {
			noRefinementRoot: 'applied-facets-no-results',
			list: 'applied-facets__list',
			item: 'applied-facets__list-item',
			delete: 'applied-facets__delete',
		},
		transformItems(items) {
			return items?.map(item => ({
				...item,
				// Below empty string is to avoid any JavaScript errors in case the Facet title does not exist
				label: facetsTitles[item.label] || '',
			}));
		},
	});
};
